import { render } from "./PurchasePriceChanges.vue?vue&type=template&id=1eb99907"
import script from "./PurchasePriceChanges.vue?vue&type=script&lang=js"
export * from "./PurchasePriceChanges.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__